const dialog = document.querySelector('#room-dialog-modal');

function openModal(url) {
  document.getElementById('iframeContent').src = url;
  document.body.classList.add('overflow-hidden');
  dialog.showModal();
}

function closeModal() {
  document.getElementById('iframeContent').src = '';
  document.body.classList.remove('overflow-hidden');
  dialog.close();
}

document.addEventListener('DOMContentLoaded', () => {
  const accomodationsDialog = document?.querySelector('#room-dialog-modal');
  if (accomodationsDialog) {
    const roomTourLink = '.c-button--tour';

    document.querySelectorAll(roomTourLink).forEach((item) => {
      item?.addEventListener('click', (e) => {
        e.preventDefault();
        const iframeLink = e.target.href;
        openModal(iframeLink);
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target === document.getElementById('room-dialog-modal')) {
        closeModal();
      }

      if (event.target.classList.contains('room-dialog__button')
      || event.target.closest('.room-dialog__button')) {
        closeModal();
      }
    });
  }
});
